import { render, staticRenderFns } from "./PageStatements.vue?vue&type=template&id=6152bb87&"
import script from "./PageStatements.vue?vue&type=script&lang=ts&"
export * from "./PageStatements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports